import { Column } from "data/table.data";
import { convertRegNumber } from "utils/converter";

export type typeStoreType =
  | "CORPORATE"
  | "INDIVIDUAL"
  | "BANK_ACCOUNT"
  | "BIZ_CARD"
  | "PAYEE"; // 법인사업자, 개인사업자 (일반과세자), 은행 계좌, 사업용 신용카드, 급여 지급대상자

export const STORE_TYPE_DATA: { [key in typeStoreType]: string } = {
  CORPORATE: "법인사업자",
  INDIVIDUAL: "개인사업자",
  BANK_ACCOUNT: "은행 계좌",
  BIZ_CARD: "사업용 신용카드",
  PAYEE: "급여 지급대상자",
};

export const SELECT_STORE_COLS: Column[] = [
  {
    id: "name",
    label: "거래처",
  },
  {
    id: "ceoName",
    label: "대표자",
  },
  {
    id: "type",
    label: "유형",
    renderer: (data) => STORE_TYPE_DATA[data.type as typeStoreType] || "-",
  },
  {
    id: "regNumber",
    label: "사업자등록번호",
    renderer: (data) => convertRegNumber(data.regNumber) || "-",
  },
  {
    id: "accountCode",
    label: "설정 계정코드",
    sx: { width: 100 },
  },
];
